import { ApplicationV2Dto } from '@inosio/payments-sdk';
import { Box } from '@mui/system';
import ApplicationDetailsApplicantEntityData, { ApplicantEntityDataTableField, ApplicantEntityDataTableFieldType } from './ApplicationDetailsApplicantEntityData';
import { Typography, Divider } from '@mui/material';
import { convertSqlDateToUSCalendarDate } from '../../../../shared/util/converters';
import { useState } from 'react';
import UpdateApplicationPropertyModal from './UpdateApplicationPropertyModal';

export interface ApplicationDetailsGeneralProps {
  application: ApplicationV2Dto;
}
export default function ApplicationDetailsGeneral(props: ApplicationDetailsGeneralProps) {
  const [openUpdateAppPropertyModal, setOpenUpdateAppPropertyModal] = useState(false);

  const handleBuildGeneralInfoData = (application: ApplicationV2Dto | undefined) => {
    const generalInfoData: ApplicantEntityDataTableField[] = [
      {
        label: 'Property Address',
        value: application?.PropertyAddress || '',
        editable: true,
        onEdit: () => {
          setOpenUpdateAppPropertyModal(true);
        },
      },
      {
        label: 'Desired Move In Date',
        value: application?.DesiredMoveInDate ? convertSqlDateToUSCalendarDate(application?.DesiredMoveInDate) : '(left blank)',
      },
      {
        label: 'Desired Lease Term',
        value: application?.DesiredLeaseTerm || '(left blank)',
      },
      {
        label: 'Expected Rent Amount',
        value: application?.ExpectedRentAmount || '(left blank)',
        fieldType: ApplicantEntityDataTableFieldType.MinorUnitsNumber,
      },
      {
        label: 'Viewed the Property',
        value: application?.HasSeenProperty ? 'Yes' : 'No',
      },
      {
        label: 'Showing Agent Company',
        value: application?.ShowingAgentCompany || '(left blank)',
      },
      {
        label: 'Showing Agent Name',
        value: application?.ShowingAgentName || '(left blank)',
      },
      {
        label: 'Showing Agent Contact',
        value: application?.ShowingAgentContactDetails || '(left blank)',
      },
      {
        label: 'Note from the Applicant',
        value: application?.Memo || '(left blank)',
      },
    ];

    return generalInfoData;
  };
  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'auto',
        padding: 2,
        height: 'calc( 100vh - 294px )',
        '&::-webkit-scrollbar': {
          width: 7,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
          borderRadius: '24px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'darkgrey',
          borderRadius: '24px',
        },
      }}
    >
      <Typography sx={{ fontFamily: 'Work Sans !important', fontWeight: 'bold', marginBottom: 1 }}>General Information:</Typography>
      <Divider sx={{ marginY: 1, borderBottomWidth: 1, backgroundColor: 'black' }} />
      <ApplicationDetailsApplicantEntityData tableData={handleBuildGeneralInfoData(props.application)} />
      <UpdateApplicationPropertyModal
        open={openUpdateAppPropertyModal}
        onClose={() => {
          setOpenUpdateAppPropertyModal(false);
        }}
        oldPropertyName={props.application?.PropertyAddress || ''}
        appUuid={props.application.Uuid}
      />
    </Box>
  );
}
